import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import type { ReactNode } from "react";

/**
 * 图标映射配置
 * 将图标名称字符串映射到实际的 React 组件
 */
export const iconMap: Record<string, ReactNode> = {
  SearchOutlined: <SearchOutlined />,
  ReloadOutlined: <ReloadOutlined />,
};

/**
 * 根据图标名称获取图标组件
 * @param iconName - 图标名称
 * @returns React 图标组件或 undefined
 */
export const getIcon = (iconName?: string): ReactNode | undefined => {
  if (!iconName) return undefined;
  return iconMap[iconName];
};
